import { Radio } from 'semantic-ui-react';

export default Radio;
